/**
 * SWORD API
 * SWORD service API to be consumed by SWORD Angular SPA. Interfaces with Entra ID and DataBricks.
 *
 * OpenAPI spec version: v1
 * Contact: donnie.hyatt@tnedu.gov
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Represents search criteria for querying student records.
 */
export interface StudentSearchTerms { 
    /**
     * Gets or sets a collection of district identifiers to filter the search.
     */
    districtIds?: Array<string>;
    /**
     * Gets or sets a collection of school identifiers to filter the search.
     */
    schoolIds?: Array<string>;
    /**
     * Gets or sets the academic year for the search.
     */
    years?: Array<number>;
    /**
     * Calculated EL Service Years
     */
    calculatedELServiceYears?: number;
    /**
     * Date first enrolled in public school
     */
    dateFirstEnrolledInPublicSchool?: string;
    /**
     * Demographic
     */
    demographic?: string;
    /**
     * EL Service Years
     */
    elServiceYears?: string;
    /**
     * English language background
     */
    englishLanguageBackground?: boolean;
    immigration?: string;
    /**
     * Native language
     */
    nativeLanguage?: Array<string>;
    /**
     * Race
     */
    race?: string;
    /**
     * Year entered 9th grade
     */
    yearEntered9thGrade?: number;
    /**
     * Gets or sets the enrollment code for filtering.
     */
    enrollmentCode?: string;
    /**
     * Gets or sets the enrollment classification for filtering.
     */
    enrollmentClassification?: string;
    /**
     * Gets or sets the funding eligibility criteria for filtering.
     */
    fundingEligibility?: Array<string>;
    /**
     * Gets or sets the attendance date for filtering.
     */
    attendanceDate?: string;
    /**
     * Gets or sets the attendance type for filtering.
     */
    attendanceType?: Array<string>;
    /**
     * Reporting begin date
     */
    reportingBeginDate?: string;
    /**
     * Reporting end date
     */
    reportingEndDate?: string;
    /**
     * Class period duration
     */
    classPeriodDuration?: number;
    /**
     * Class period meeting days
     */
    classPeriodMeetingDays?: Array<string>;
    /**
     * Class period name
     */
    classPeriodName?: string;
    /**
     * Gets or sets the enrollment period start date for filtering.
     */
    enrollmentPeriodStartDate?: string;
    /**
     * Gets or sets the enrollment period end date for filtering.
     */
    enrollmentPeriodEndDate?: string;
    /**
     * Gets or sets the classification for filtering.
     */
    classificationCode?: string;
    /**
     * Gets or sets the classification end date for filtering.
     */
    classificationEndDate?: string;
    /**
     * Classification start date
     */
    classificationStartDate?: string;
    /**
     * Alpha grade
     */
    alphaGradeInput?: Array<string>;
    /**
     * Year class was taken
     */
    classSchoolYear?: number;
    /**
     * Term class was taken
     */
    classTerm?: Array<string>;
    /**
     * Credits attempted
     */
    creditsAttempted?: number;
    /**
     * Gets or sets the credits earned filter.
     */
    creditsEarnedInput?: string;
    /**
     * Gets or sets the numeric grade filter.
     */
    numericGradeInput?: string;
    /**
     * Quality points
     */
    qualityPoints?: number;
    /**
     * Gets or sets the option number filter.
     */
    optionNumberInput?: string;
    /**
     * Gets or sets the vocational program item filter.
     */
    vocationalProgramItem?: string;
    /**
     * Gets or sets the vocational report period filter.
     */
    vocationalReportPeriod?: string;
    /**
     * Gets or sets the vocational student ADA (Average Daily Attendance) filter.
     */
    vocationalStudentAda?: string;
    /**
     * Gets or sets the vocational student ADM (Average Daily Membership) filter.
     */
    vocationalStudentAdm?: string;
    /**
     * Gets or sets the club begin date for filtering.
     */
    clubBeginDate?: string;
    /**
     * Gets or sets the club end date for filtering.
     */
    clubEndDate?: string;
    /**
     * Gets or sets the club identifier for filtering.
     */
    clubId?: string;
    /**
     * CTSO chapter ID
     */
    ctsoChapterId?: string;
    /**
     * CTSO membership ID
     */
    ctsoMembershipId?: string;
    endOfServiceDate?: string;
    /**
     * P=Promoted, R=Retained, D =Demoted
     */
    eosAction?: string;
    compDocDate?: string;
    compDocType?: string;
    /**
     * EA=Early Grad, SP= Spring Grad, SU=Summer Grad
     */
    compDocPeriod?: string;
    /**
     * Ineligibility funding begin date
     */
    ineligibilityFundingBeginDate?: string;
    /**
     * Ineligibility funding end date
     */
    ineligibilityFundingEndDate?: string;
    /**
     * Gets or sets the begin date for filtering.
     */
    beginDate?: string;
    /**
     * Gets or sets the class start dates for filtering.
     */
    classStartDates?: string;
    dateOfBirth?: string;
    /**
     * Gets or sets the enrollment period end date for filtering.
     */
    enrollmentPeriodEnd?: string;
    /**
     * Gets or sets the enrollment period start date for filtering.
     */
    enrollmentPeriodStart?: string;
    /**
     * Gets or sets a collection of grade levels to filter the search.
     */
    grades?: Array<string>;
    nameFirst?: string;
    nameLast?: string;
    nameMiddle?: string;
    ssid?: number;
    /**
     * Years as string
     */
    readonly years_?: Array<string>;
}
